import type { QuestionFileModel } from 'survey-core';

export const initializeSurveyFileInput = (question: QuestionFileModel, questionElement: HTMLElement) => {
  const input = questionElement.querySelector<HTMLInputElement>('input[type="file"]');
  if (!input || input.onchange) return;

  // SurveyJS installs onchange only when its styled label is clicked. Safari
  // and assistive technology can open the native input directly instead.
  // Use the same property so the styled chooser can replace this handler;
  // adding a second change listener would upload each selection twice.
  input.onchange = () => {
    if (question.isReadOnly || input.disabled) return;
    const files = Array.from(input.files ?? []);
    if (!files.length) return;

    // Allow selecting the same file again after a rejected or failed upload.
    input.value = '';
    question.loadFiles(files);
  };
};
